// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  OfferingPackagesFiltersModalCoachingFocusFragmentDoc,
  OfferingPackagesFiltersModalSchoolFragmentDoc,
} from './OfferingPackagesFiltersModal.generated';
import { FeaturedServicesFilterCategoryFragmentDoc } from './FeaturedServicesFilter.generated';
import {
  OfferingPackageCardOfferingPackageFragmentDoc,
  OfferingPackageCardCoachFragmentDoc,
} from '../../package/__generated-gql-types__/OfferingPackageCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferingPackagesSubCategoryFragment = {
  __typename?: 'SubCategory';
  id: string;
};

export type OfferingPackagesCoachingFocusFragment = {
  __typename?: 'CoachingFocus';
  id: string;
  name: string;
};

export type OfferingPackagesCategoryFragment = {
  __typename?: 'Category';
  id: string;
  slug: string;
  name: string;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  comprehensiveFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  featuredFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
};

export type OfferingPackagesSchoolFragment = {
  __typename?: 'School';
  id: string;
  name: string;
  logoLink?: string | null;
};

export type OfferingPackagesOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  slug?: string | null;
  name: string;
  subTitle?: string | null;
  isUniversalPackage: boolean;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
  coach: { __typename?: 'Coach'; id: string; slug: string };
};

export type OfferingPackagesSearchPackagesQueryVariables = Types.Exact<{
  keyword?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryUrn: Types.Scalars['CategoryUrn']['input'];
  subCategoryUrns?: Types.InputMaybe<
    | Array<Types.Scalars['SubCategoryUrn']['input']>
    | Types.Scalars['SubCategoryUrn']['input']
  >;
  coachingFocusListFilter?: Types.InputMaybe<
    | Array<Types.Scalars['CoachingFocusUrn']['input']>
    | Types.Scalars['CoachingFocusUrn']['input']
  >;
  priceFilter?: Types.InputMaybe<Types.IntRangeInput>;
  schoolsSort?: Types.InputMaybe<
    | Array<Types.Scalars['SchoolUrn']['input']>
    | Types.Scalars['SchoolUrn']['input']
  >;
  start: Types.Scalars['Int']['input'];
  count: Types.Scalars['Int']['input'];
}>;

export type OfferingPackagesSearchPackagesQuery = {
  __typename?: 'Query';
  searchPackages: {
    __typename?: 'PackageSearchResponse';
    total: number;
    results: Array<{
      __typename?: 'OfferingPackage';
      id: string;
      slug?: string | null;
      name: string;
      subTitle?: string | null;
      isUniversalPackage: boolean;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        price: number;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
      coach: { __typename?: 'Coach'; id: string; slug: string };
    }>;
  };
};

export type OfferingPackagesLelandPackagesQueryVariables = Types.Exact<{
  categoryUrn: Types.Scalars['CategoryUrn']['input'];
}>;

export type OfferingPackagesLelandPackagesQuery = {
  __typename?: 'Query';
  lelandPackages: {
    __typename?: 'PackageSearchResponse';
    total: number;
    results: Array<{
      __typename?: 'OfferingPackage';
      id: string;
      slug?: string | null;
      name: string;
      subTitle?: string | null;
      isUniversalPackage: boolean;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        price: number;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
      coach: { __typename?: 'Coach'; id: string; slug: string };
    }>;
  };
};

export const OfferingPackagesSubCategoryFragmentDoc = gql`
  fragment OfferingPackages_SubCategory on SubCategory {
    id
  }
`;
export const OfferingPackagesCoachingFocusFragmentDoc = gql`
  fragment OfferingPackages_CoachingFocus on CoachingFocus {
    ...OfferingPackagesFiltersModal_CoachingFocus
  }
  ${OfferingPackagesFiltersModalCoachingFocusFragmentDoc}
`;
export const OfferingPackagesCategoryFragmentDoc = gql`
  fragment OfferingPackages_Category on Category {
    id
    slug
    coachingFocusList {
      ...OfferingPackages_CoachingFocus
    }
    comprehensiveFocusList {
      ...OfferingPackages_CoachingFocus
    }
    ...FeaturedServicesFilter_Category
  }
  ${OfferingPackagesCoachingFocusFragmentDoc}
  ${FeaturedServicesFilterCategoryFragmentDoc}
`;
export const OfferingPackagesSchoolFragmentDoc = gql`
  fragment OfferingPackages_School on School {
    ...OfferingPackagesFiltersModal_School
  }
  ${OfferingPackagesFiltersModalSchoolFragmentDoc}
`;
export const OfferingPackagesOfferingPackageFragmentDoc = gql`
  fragment OfferingPackages_OfferingPackage on OfferingPackage {
    id
    ...OfferingPackageCard_OfferingPackage
  }
  ${OfferingPackageCardOfferingPackageFragmentDoc}
`;
export const OfferingPackagesSearchPackagesDocument = gql`
  query OfferingPackages_SearchPackages(
    $keyword: String
    $categoryUrn: CategoryUrn!
    $subCategoryUrns: [SubCategoryUrn!]
    $coachingFocusListFilter: [CoachingFocusUrn!]
    $priceFilter: IntRangeInput
    $schoolsSort: [SchoolUrn!]
    $start: Int!
    $count: Int!
  ) {
    searchPackages(
      keyword: $keyword
      categoryUrn: $categoryUrn
      subCategoriesFilter: $subCategoryUrns
      coachingFocusListFilter: $coachingFocusListFilter
      priceFilter: $priceFilter
      schoolsSort: $schoolsSort
      start: $start
      count: $count
    ) {
      results {
        ...OfferingPackages_OfferingPackage
      }
      total
    }
  }
  ${OfferingPackagesOfferingPackageFragmentDoc}
`;

/**
 * __useOfferingPackagesSearchPackagesQuery__
 *
 * To run a query within a React component, call `useOfferingPackagesSearchPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagesSearchPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagesSearchPackagesQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      categoryUrn: // value for 'categoryUrn'
 *      subCategoryUrns: // value for 'subCategoryUrns'
 *      coachingFocusListFilter: // value for 'coachingFocusListFilter'
 *      priceFilter: // value for 'priceFilter'
 *      schoolsSort: // value for 'schoolsSort'
 *      start: // value for 'start'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useOfferingPackagesSearchPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagesSearchPackagesQuery,
    OfferingPackagesSearchPackagesQueryVariables
  > &
    (
      | {
          variables: OfferingPackagesSearchPackagesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagesSearchPackagesQuery,
    OfferingPackagesSearchPackagesQueryVariables
  >(OfferingPackagesSearchPackagesDocument, options);
}
export function useOfferingPackagesSearchPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagesSearchPackagesQuery,
    OfferingPackagesSearchPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagesSearchPackagesQuery,
    OfferingPackagesSearchPackagesQueryVariables
  >(OfferingPackagesSearchPackagesDocument, options);
}
export function useOfferingPackagesSearchPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingPackagesSearchPackagesQuery,
        OfferingPackagesSearchPackagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagesSearchPackagesQuery,
    OfferingPackagesSearchPackagesQueryVariables
  >(OfferingPackagesSearchPackagesDocument, options);
}
export type OfferingPackagesSearchPackagesQueryHookResult = ReturnType<
  typeof useOfferingPackagesSearchPackagesQuery
>;
export type OfferingPackagesSearchPackagesLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagesSearchPackagesLazyQuery
>;
export type OfferingPackagesSearchPackagesSuspenseQueryHookResult = ReturnType<
  typeof useOfferingPackagesSearchPackagesSuspenseQuery
>;
export type OfferingPackagesSearchPackagesQueryResult = Apollo.QueryResult<
  OfferingPackagesSearchPackagesQuery,
  OfferingPackagesSearchPackagesQueryVariables
>;
export const OfferingPackagesLelandPackagesDocument = gql`
  query OfferingPackages_LelandPackages($categoryUrn: CategoryUrn!) {
    lelandPackages(
      categoryUrn: $categoryUrn
      visibility: PUBLIC
      status: LIVE
    ) {
      results {
        ...OfferingPackages_OfferingPackage
      }
      total
    }
  }
  ${OfferingPackagesOfferingPackageFragmentDoc}
`;

/**
 * __useOfferingPackagesLelandPackagesQuery__
 *
 * To run a query within a React component, call `useOfferingPackagesLelandPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagesLelandPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagesLelandPackagesQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useOfferingPackagesLelandPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagesLelandPackagesQuery,
    OfferingPackagesLelandPackagesQueryVariables
  > &
    (
      | {
          variables: OfferingPackagesLelandPackagesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagesLelandPackagesQuery,
    OfferingPackagesLelandPackagesQueryVariables
  >(OfferingPackagesLelandPackagesDocument, options);
}
export function useOfferingPackagesLelandPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagesLelandPackagesQuery,
    OfferingPackagesLelandPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagesLelandPackagesQuery,
    OfferingPackagesLelandPackagesQueryVariables
  >(OfferingPackagesLelandPackagesDocument, options);
}
export function useOfferingPackagesLelandPackagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OfferingPackagesLelandPackagesQuery,
        OfferingPackagesLelandPackagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagesLelandPackagesQuery,
    OfferingPackagesLelandPackagesQueryVariables
  >(OfferingPackagesLelandPackagesDocument, options);
}
export type OfferingPackagesLelandPackagesQueryHookResult = ReturnType<
  typeof useOfferingPackagesLelandPackagesQuery
>;
export type OfferingPackagesLelandPackagesLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagesLelandPackagesLazyQuery
>;
export type OfferingPackagesLelandPackagesSuspenseQueryHookResult = ReturnType<
  typeof useOfferingPackagesLelandPackagesSuspenseQuery
>;
export type OfferingPackagesLelandPackagesQueryResult = Apollo.QueryResult<
  OfferingPackagesLelandPackagesQuery,
  OfferingPackagesLelandPackagesQueryVariables
>;
